import type { OrganizationSettings, OrganizationSettingsRequest } from "@shyne/shared/api";
import { MemberOrganization } from "@/models/organization.model.ts";
import { store } from "@/lib/store.ts";
import { api } from "@/lib/api";
import { contentTypeOf, putPhoto } from "@/lib/appointment-photos";
import { toMemberOrganization } from "@/repositories/organization-records";

function activeOrganizationId(): string {
    const organization = store.getState().organization.activeOrgId;
    if (!organization) throw new Error("No active organization");
    return organization;
}

export const OrganizationRepository = {
    async getUserOrganizations(): Promise<MemberOrganization[]> {
        const { items } = await api.myOrganizations();
        return items.map(toMemberOrganization);
    },

    async getCurrentOrganization(): Promise<OrganizationSettings> {
        return api.organizations.settings(activeOrganizationId());
    },

    async update(settings: OrganizationSettingsRequest): Promise<OrganizationSettings> {
        return api.organizations.saveSettings(activeOrganizationId(), settings);
    },

    async uploadImage(file: File): Promise<OrganizationSettings> {
        const organization = activeOrganizationId();
        const contentType = contentTypeOf(file);
        const upload = await api.organizations.logoUpload(organization, { contentType });
        await putPhoto(upload, file, contentType);
        return api.organizations.setLogo(organization, { logoUrl: upload.photoUrl });
    },
};
